import { autorun, makeAutoObservable } from 'mobx';
import { injectable } from 'inversify';
import { OsiData } from '@mobx/interfaces';
import { applyFilter } from '@widgets/osiList/utils';
import { ProfileModule } from '@/app/stores/mobx/services/profile';

@injectable()
export class OsiListViewModel {
  filter = '';

  osis: OsiData[] = [];

  constructor(private profileModule: ProfileModule) {
    makeAutoObservable(this);

    autorun(() => {
      this.osis = this.profileModule.userData.osis;
    });
  }

  // Отфильтрованный поиском список (то, что реально показываем в карточках).
  getOsis = () => applyFilter(this.osis, this.filter);

  // OSI-806: исходный (НЕ отфильтрованный) список ОСИ пользователя.
  // Нужен, чтобы отличить «у пользователя вообще нет ОСИ» (блок не рендерим совсем)
  // от «поиск ничего не нашёл» (показываем состояние «Не найдено»).
  // Логику фильтрации не трогаем — это отдельный геттер.
  getAllOsis = () => this.osis;

  changeFilter(value: string) {
    this.filter = value;
  }
}
